import styled from 'styled-components';
import { colors } from '../../styles/colors';

export const CarouselContainer = styled.div`
  width: 100%;
  max-width: 420px; /* limite máximo para telas grandes */
  margin: 0 auto;
  text-align: center;
`;

export const ImageWrapper = styled.div`
  position: relative;
`;

export const MainImage = styled.img`
  width: 380px;
  height: 400px;
  object-fit: cover;
  border-radius: 8px;

  @media (max-width: 500px) {
    height: 300px; /* altura menor em telas pequenas */
  }
`;

export const NavButton = styled.button<{ position: 'left' | 'right' }>`
  position: absolute;
  top: 50%;
  ${({ position }) => (position === 'left' ? 'left: 10px;' : 'right: 10px;')}
  transform: translateY(-50%);
  background: ${colors.Surface700};
  opacity: 0.8;
  color: white;
  border: none;
  padding: 6px 10px;
  border-radius: 4px;
  cursor: pointer;

  &:hover {
    filter: brightness(0.8);
  }
`;

export const DeleteButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  background: red;
  color: white;
  border: none;
  padding: 4px 8px;
  border-radius: 4px;
  cursor: pointer;

  &:hover {
    background: darkred;
  }
`;

export const ThumbnailsWrapper = styled.div`
  position: relative;
  margin-top: 10px;
`;

export const Thumbnails = styled.div`
  display: flex;
  flex-wrap: nowrap;
  gap: 5px;
  overflow-x: auto;
  padding-bottom: 10px;

  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE/Edge antigo */
  &::-webkit-scrollbar {
    display: none; /* Chrome, Edge, Brave, Safari */
  }
`;

export const ScrollTrack = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  height: 4px;
  width: 100%;
  background: #e6e6e6;
  border-radius: 2px;
`;

export const ScrollThumb = styled.div<{ width: number; left: number }>`
  position: absolute;
  bottom: 0;
  height: 4px;
  background: ${colors.Blue300};
  border-radius: 2px;
  width: ${({ width }) => width}%;
  left: ${({ left }) => left}%;
  transition: left 0.05s linear;
`;

export const Thumbnail = styled.img<{ active: boolean }>`
  width: 20vw; /* ocupa 20% da tela */
  max-width: 100px; /* não ultrapassa 100px */
  height: 100px;
  border-radius: 4px;
  object-fit: cover;
  cursor: pointer;
  flex: 0 0 auto;
  border: ${({ active }) => (active ? `2px solid ${colors.Blue300}` : '2px solid transparent')};
`;

export const LabelCountImages = styled.span`
  font-size: 14px;
  color: ${colors.Blue300};
  font-weight: 600;
  margin-bottom: 5px;
`;

export const DownloadButton = styled.a`
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  width: 50%;
  background: ${colors.brand.principal};
  color: white;
  border: none;
  padding: 6px 10px;
  border-radius: 4px;
  text-decoration: none;
  font-weight: 500;
  justify-content: center;
  align-items: center;
  gap: 10px;
  cursor: pointer;

  &:hover {
    filter: brightness(0.8);
    color: white
  }
`;
